var _rect, _rect2, _rect3, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 127,
    viewBox: "0 0 143 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 46,
    width: 15,
    height: 38,
    rx: 7.5,
    fill: "#8CCE56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.677,
    y: 35,
    width: 14.6462,
    height: 53,
    rx: 7.32308,
    fill: "#DF8383"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 51,
    width: 14.6462,
    height: 27.9324,
    rx: 7.32308,
    fill: "#8CCE56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77059 96.4763C1.06309 99.3644 -0.411813 105.522 2.47631 110.229C5.36443 114.937 11.5219 116.412 16.2294 113.524L5.77059 96.4763ZM31.1673 80.8951L5.77059 96.4763L16.2294 113.524L41.6261 97.9425L31.1673 80.8951Z",
    fill: "#1DA3B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 63.5,
    r: 53.5,
    stroke: "url(#paint0_linear_31_73)",
    strokeWidth: 20
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_73",
    x1: 149,
    y1: 80.5,
    x2: 36.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AD8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsIcon);
export default __webpack_public_path__ + "static/media/deals_icon.70c69e2b4b520150c4c24b528d0576c8.svg";
export { ForwardRef as ReactComponent };